import { render, staticRenderFns } from "./resolvability.vue?vue&type=template&id=72b72cfe&scoped=true"
import script from "./resolvability.vue?vue&type=script&lang=js"
export * from "./resolvability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b72cfe",
  null
  
)

export default component.exports